import { render, staticRenderFns } from "./index.vue?vue&type=template&id=968bd136&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=968bd136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968bd136",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('968bd136')) {
      api.createRecord('968bd136', component.options)
    } else {
      api.reload('968bd136', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=968bd136&scoped=true&", function () {
      api.rerender('968bd136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RemixIcon/index.vue"
export default component.exports